
import React, { useState } from 'react';
import { Link } from 'react-router-dom';

export const Header: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header className="fixed top-0 left-0 right-0 bg-white/95 backdrop-blur-sm border-b border-gray-100 z-50">
      <div className="px-4 py-3">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-2">
            <div className="w-8 h-8 bg-emerald-500 rounded-full flex items-center justify-center">
              <i className="ri-store-2-fill text-white text-lg"></i>
            </div>
            <span className="text-xl font-bold text-gray-800" style={{ fontFamily: 'Pacifico, serif' }}>
              FamilyMart
            </span>
          </Link>

          {/* Search Bar */}
          <div className="flex-1 max-w-xs mx-4">
            <div className="relative">
              <input
                type="text"
                placeholder="Search products..."
                className="w-full pl-10 pr-4 py-2 bg-gray-50 border-none rounded-full text-sm focus:outline-none focus:ring-2 focus:ring-emerald-500"
              />
              <i className="ri-search-line absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400"></i>
            </div>
          </div>

          {/* Actions */}
          <div className="flex items-center space-x-3">
            <button className="w-10 h-10 flex items-center justify-center rounded-full hover:bg-gray-100">
              <i className="ri-heart-line text-gray-600 text-lg"></i>
            </button>
            <button className="w-10 h-10 flex items-center justify-center rounded-full hover:bg-gray-100 relative">
              <i className="ri-shopping-cart-line text-gray-600 text-lg"></i>
              <span className="absolute -top-1 -right-1 w-5 h-5 bg-emerald-500 text-white text-xs rounded-full flex items-center justify-center">
                3
              </span>
            </button>
            <button 
              className="w-10 h-10 flex items-center justify-center rounded-full hover:bg-gray-100"
              onClick={() => setIsMenuOpen(!isMenuOpen)}
            >
              <i className="ri-menu-line text-gray-600 text-lg"></i>
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="mt-4 pb-4 border-t border-gray-100">
            <nav className="flex flex-col space-y-3 pt-4">
              <Link to="/categories" className="text-gray-700 hover:text-emerald-500 font-medium">
                Categories
              </Link>
              <Link to="/deals" className="text-gray-700 hover:text-emerald-500 font-medium">
                Deals
              </Link>
              <Link to="/new-arrivals" className="text-gray-700 hover:text-emerald-500 font-medium">
                New Arrivals
              </Link>
              <Link to="/account" className="text-gray-700 hover:text-emerald-500 font-medium">
                My Account
              </Link>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};
